enum Routes {
  App = '/',

  SignIn = '/sign-in',
  SignUp = '/sign-up',
  ForgotPassword = '/forgot-password',

  // Admin routes
  AdminSignIn = '/admin/sign-in',
  AdminDashboard = '/admin/dashboard',
  AdminContractors = '/admin/dashboard/contractors',
  AdminContractorDetails = '/admin/dashboard/contractors/:id',
  AdminResourcingCompanies = '/admin/dashboard/resourcing-companies',
  AdminResourcingCompanyDetails = '/admin/dashboard/resourcing-companies/:id',
  AdminFeedback = '/admin/dashboard/feedback',
  AdminFeedbackDetails = '/admin/dashboard/feedback/:id',
  AdminProfile = '/admin/dashboard/profile',
  AdminAnalytics = '/admin/dashboard/analytics',
  AdminSubscription = '/admin/dashboard/subscriptions',

  ManagerEmailConfirmation = '/manager/email-confirmation',
  ManagerSetUp = '/manager/setup',
  ManagerInviteMembers = '/manager/invite-members',

  RecruiterSignUp = '/recruiter/sign-up',
  RecruiterSetUp = '/recruiter/setup',

  Dashboard = '/dashboard',
  Analytics = '/dashboard/analytics',
  AgencySettings = '/dashboard/agency-settings',
  AgencyMembers = '/dashboard/members',
  AgencyInvites = '/dashboard/invites',
  Contracts = '/dashboard/contracts',
  Contract = '/dashboard/contracts/:id',
  ContractCreate = '/dashboard/contracts/create',
  ContractEdit = '/dashboard/contracts/:id/edit',
  Applications = '/dashboard/applications',
  Application = '/dashboard/applications/:id',
  Inbox = '/dashboard/inbox',
  Courses = '/dashboard/courses',
  CourseCreate = '/dashboard/courses/create',
  CourseDetails = '/dashboard/courses/:id',
  CourseEdit = '/dashboard/courses/:id/edit',
  Companies = '/dashboard/companies',

  Profile = '/profile',
  NotificationsSettings = '/profile/notifications',
  PersonalSettings = '/profile/personal',

  ApplicationSettings = '/profile/application',
  AgencyDelete = '/agency-delete',
  AgencyBlocked = '/agency-blocked',
}

export default Routes;
